import {apiContainer, utils} from '@wallaby-ui/core';

import {getGridApiStateId, getGridStateId} from './grid_helpers';
import {gridSlice} from './grid_slice';

export const getReducers = (key: string, hasApiState: boolean) => ({
  [getGridStateId(key)]: utils.reducerUtils.createFilteredReducer(
    gridSlice.reducer,
    (action) => {
      const stateId = action.stateId ?? action.meta?.stateId;
      return stateId === getGridStateId(key);
    }
  ),
  ...(hasApiState
    ? {
        [getGridApiStateId(key)]: utils.reducerUtils.createFilteredReducer(
          apiContainer.apiSlice.reducer,
          (action) => {
            const stateId = action.stateId ?? action.meta?.stateId;
            return stateId === getGridApiStateId(key);
          }
        ),
      }
    : {}),
});
